import { useEffect, useState } from "react";
import Button from "../../../Custom/Button/Button";
import styles from "./styles";
import EvidencijeObrazac1Dodavanje from "./EvidencijeObrazac1Dodavanje";
import { useGlobalContext } from "../../../../Context/Context";
import axios from "axios";

const SIGNATURE_URL = "https://data.nadzor.app/potpis.jpg";

const cs = {
  border: "1px solid black",
  padding: "4px",
  textAlign: "center",
  verticalAlign: "middle",
  fontSize: "14px",
};

function EvidencijeObrazac1() {
  const [data, setData] = useState([]);
  const [isDodavanje, setIsDodavanje] = useState(false);

  const { selectedMainEntity, baseUrl, apiKey, loggedUser } = useGlobalContext();
  const [companyHeader, setCompanyHeader] = useState({
  name: "",
  address: "",
  pib: ""
});



 const fetchHeaderData = async () => {
  // Use either company_id (from selectedMainEntity) or id (from loggedUser)
  const id = selectedMainEntity?.company_id || selectedMainEntity?.id;
  
  if (!id || !loggedUser?.id) return;

  try {
    const { data: res } = await axios.post(
      `${baseUrl}/companies/readCompanyDetails.php`,
      { 
        user_id: loggedUser.id, 
        api_key: apiKey,
        company_id: id
      }
    );
    
    if (res.status === 200) {
      setCompanyHeader({
        name: res.data.company_name,
        address: res.data.company_address,
        pib: res.data.pib
      });
    }
  } catch (e) {
    console.error("Error fetching header info:", e);
  }
};

const fetchData = async () => {
  const id = selectedMainEntity?.company_id || selectedMainEntity?.id;
  try {
    const { data: res } = await axios.post(
      `${baseUrl}/evidencija1/read.php`,
      { company_id: id }
    );
    if (res.status === 200) setData(res.data);
  } catch (e) {
    console.error("Greška:", e);
  }
};

// 3. Update useEffect to trigger both calls when the selection changes
useEffect(() => {
  if (selectedMainEntity) {
    fetchHeaderData();
    fetchData();
  }
}, [selectedMainEntity]);

  console.log(selectedMainEntity)

  useEffect(() => {
    if (!selectedMainEntity?.company_id) return;
    fetchData();
  }, [selectedMainEntity]);

  // Grupišemo po workplace_id + employee_id
  const buildGroups = () => {
    const groups = [];
    let i = 0;
    while (i < data.length) {
      const key = `${data[i].workplace_id}_${data[i].employee_id}`;
      let j = i;
      while (j < data.length && `${data[j].workplace_id}_${data[j].employee_id}` === key) j++;
      groups.push(data.slice(i, j));
      i = j;
    }
    return groups;
  };

  const groups = buildGroups();

  // Za svaku grupu pravimo redove:
  // - prethodni redovi (1 red po prethodnom)
  // - periodicni redovi (N redova, label merged)
  const buildGroupRows = (group) => {
    const prethodni = group.filter(r => r.tip_pregleda === "PRETHODNI");
    const periodicni = group.filter(r => r.tip_pregleda === "PERIODICNI");
    const rows = [];

    prethodni.forEach(r => {
      rows.push({ ...r, labelType: "PRETHODNI", labelRowspan: 1, showLabel: true });
    });

    periodicni.forEach((r, idx) => {
      rows.push({
        ...r,
        labelType: "PERIODICNI",
        labelRowspan: periodicni.length,
        showLabel: idx === 0,
      });
    });

    return rows;
  };

  console.log(selectedMainEntity);

  const handleStampaj = async () => {
    const el = document.getElementById("print-obrazac1");
    if (!el) return;
    const useSignature = window.confirm("Da li želite da dodate stranicu sa potpisom?");
    let signatureHtml = "";
    if (useSignature) {
      signatureHtml = `<div style="page-break-before:always;"><div style="width:287mm;height:200mm;margin:0 auto;position:relative;background:#fff;"><img src="${SIGNATURE_URL}" style="position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);"/></div></div>`;
    }
    const printWindow = window.open("", "_blank");
    if (!printWindow) { alert("Popup blokiran."); return; }
    printWindow.document.write(`<html><head><meta charset="utf-8"/><style>@page{size:A4 landscape;margin:5mm;}body{margin:0;padding:5mm;font-family:sans-serif;font-size:11px;}table{width:100%;border-collapse:collapse;}td,th{border:1px solid black;padding:3px;text-align:center;vertical-align:middle;font-size:11px;}hr{width:80%;margin:0 auto 5px;}</style></head><body>${el.innerHTML}${signatureHtml}</body></html>`);
    printWindow.document.close();
    printWindow.onload = () => { printWindow.focus(); printWindow.print(); printWindow.close(); };
  };

  const formatOcenaCir = (text) => {
    if (text === "SPOSOBAN") {
      return "СПОСОБАН"
    } else if (text === "NIJE SPOSOBAN") {
      return "НИЈЕ СПОСОБАН"
    } else {
      return "НИЈЕ ОДАБРАНО"
    }
  }

  return (
    <>
      <style>{`
        @media print {
          @page { size: A4 landscape; margin: 5mm; }
          body * { visibility: hidden; }
          #print-obrazac1, #print-obrazac1 * { visibility: visible !important; }
          #print-obrazac1 { position:absolute !important; top:0 !important; left:0 !important; width:100% !important; }
          #print-obrazac1 table { width:100% !important; border-collapse:collapse !important; }
          #print-obrazac1 td, #print-obrazac1 th { border:1px solid black !important; padding:3px !important; font-size:11px !important; }
        }
      `}</style>

      <div style={{ fontSize: "14px", height: "100%", width: "100%" }}>
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", height: "100%" }}>

          <div
            id="print-obrazac1"
            style={{ overflowY: "auto", backgroundColor: "white", padding: "20px", border: "1.5px solid #9f9f9f", height: "100%" }}
          >
            <div style={{ fontWeight: "bold", textAlign: "center", marginBottom: "20px" }}>
              <div>Образац 1</div>
              <div>ЕВИДЕНЦИЈА О РАДНИМ МЕСТИМА СА ПОВЕЋАНИМ РИЗИКОМ, ЗАПОСЛЕНИМА КОЈИ ОБАВЉАЈУ ПОСЛОВЕ НА РАДНИМ МЕСТИМА СА ПОВЕЋАНИМ РИЗИКОМ И ЛЕКАРСКИХ ПРЕГЛЕДА ЗАПОСЛЕНИХ КОЈИ ОБАВЉАЈУ ТЕ ПОСЛОВЕ</div>
            </div>

            <div style={{ display: "flex", marginBottom: "20px" }}>
              <div style={{ width: "33%", textAlign: "center" }}>
                {selectedMainEntity.company_name}
                <hr style={{ width: "80%", margin: "0 auto 5px" }} />
                Пословно име послодавца
              </div>
              <div style={{ width: "33%", textAlign: "center" }}>
                {companyHeader.address}
                <hr style={{ width: "80%", margin: "0 auto 5px" }} />
                Адреса седишта послодавца
              </div>
              <div style={{ width: "33%", textAlign: "center" }}>
                {companyHeader.pib}
                <hr style={{ width: "80%", margin: "0 auto 5px" }} />
                ПИБ послодавца
              </div>
            </div>

            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  <th style={cs}>Редни број</th>
                  <th style={cs}>Назив радног места са повећаним ризиком које је утврђено актом о процени ризика</th>
                  <th style={cs}>Име и презиме запосленог који ради на радном месту са повећаним ризиком</th>
                  <th style={cs}>Интервал вршења периодичних лекарских прегледа изражен у месецима</th>
                  <th colSpan={2} style={cs}>Датум извршеног претходног и периодичног лекарског прегледа запосленог</th>
                  <th style={cs}>Датум када треба да се изврши следећи лекарски преглед запосленог</th>
                  <th style={cs}>Број лекарског извештаја</th>
                  <th style={cs}>Оцена здравствене способности</th>
                  <th style={cs}>Предузете мере (распоређен на друго радно место - послове)</th>
                </tr>
              </thead>
              <tbody>
                {groups.length === 0 && (
                  <tr>
                    {Array.from({ length: 10 }).map((_, i) => <td key={i} style={cs}></td>)}
                  </tr>
                )}
                {groups.map((group, gi) => {
                  const rows = buildGroupRows(group);
                  const totalRows = rows.length;
                  const first = group[0];

                  return rows.map((row, ri) => (
                    <tr key={`${gi}_${ri}`}>
                      {ri === 0 && (
                        <>
                          <td style={cs} rowSpan={totalRows}>{gi + 1}.</td>
                          <td style={cs} rowSpan={totalRows}>{first.workplace_name}</td>
                          <td style={cs} rowSpan={totalRows}>{first.ime_prezime}</td>
                          <td style={cs} rowSpan={totalRows}>{first.interval_meseci}</td>
                        </>
                      )}
                      {row.showLabel && (
                        <td style={cs} rowSpan={row.labelRowspan}>
                          {row.labelType === "PRETHODNI" ? "Претходни" : "Периодични"}
                        </td>
                      )}
                      <td style={cs}>{row.datum_pregleda}</td>
                      <td style={cs}>{row.datum_sledeci}</td>
                      <td style={cs}>{row.broj_izvestaja}</td>
                      <td style={cs}>{formatOcenaCir(row.ocena)}</td>
                      <td style={cs}>{row.mere}</td>
                    </tr>
                  ));
                })}
              </tbody>
            </table>

            <br /><br />
            <div style={{ display: "flex" }}>
              <div style={{ width: "70%", textAlign: "center" }}>
                <hr style={{ width: "80%", margin: "0 auto 5px" }} />
                Саветник/сарадник за безбедност и здравље на раду
              </div>
              <div style={{ width: "30%", textAlign: "center" }}>
                <hr style={{ width: "80%", margin: "0 auto 5px" }} />
                Послодавац
              </div>
            </div>
          </div>

          <div style={{ marginTop: "15px" }}>
            {isDodavanje ? (
              <EvidencijeObrazac1Dodavanje
                setIsDodavanje={setIsDodavanje}
                onRefresh={fetchData}
              />
            ) : (
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ display: "flex", gap: "10px" }}>
                  <div onClick={handleStampaj}>
                    <Button activation={true} style={styles.button}>ШТАМПАЈ</Button>
                  </div>
                  <div>
                    <Button activation={true} style={styles.button}>ПОШАЉИ</Button>
                  </div>
                </div>
                <div onClick={() => setIsDodavanje(true)}>
                  <Button activation={true} style={styles.button}>ДОДАЈ</Button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default EvidencijeObrazac1;